<app-spinner *ngIf="isLoading"></app-spinner>
<div *ngIf="!isLoading">
  <h1 class="email-form-title text-primary-blue-700">You're almost there!</h1>
  <div *ngIf="errorMessage">
    <app-message severity="error" [noMargin]="true" data-cy="update-error-message">
      {{ errorMessage }}
    </app-message>
  </div>
  <p class="subtitle">Set up your password to access your account.</p>
  <form [formGroup]="activateForm" (ngSubmit)="onSubmit()" formId="activateForm" data-cy="activate-account-form">
    <app-form-field
      [control]="asFormControl(activateForm.get('newPassword'))"
      name="newPassword"
      label="Password"
      type="input"
      inputType="password"
      id="newPassword"
    ></app-form-field>
    <app-form-field
      [control]="asFormControl(activateForm.get('confirmPassword'))"
      [showNotMatchError]="true"
      name="confirmPassword"
      label="Confirm Password"
      type="input"
      inputType="password"
    ></app-form-field>
    <app-password-checker passwordFieldName="newPassword"></app-password-checker>
    <app-form-footer [disabled]="disableButton" submitLabel="Submit" [noCancel]="true" [fullWidthButtons]="true">
    </app-form-footer>
  </form>
  <p class="inline-link">Already have an account? <a class="inner-link" (click)="onSignIn()">Sign In</a></p>
  <app-mobile-footer></app-mobile-footer>
</div>
